import React, { useEffect } from 'react';
import { RouterProvider, createHashRouter } from 'react-router-dom';
import ToastContainerWrapper from './generic-components/statusPopUp/StatusPopUp';
import 'react-phone-number-input/style.css';
import {
    ListTypeEntriesProvider,
    useERC
} from './context/ListTypeEntriesProvider';
import BusinessExpansionForm from './pages/BusinessExpansionForm/BusinessExpansionForm';
import PitchForm from './pages/PitchForm/PitchForm';
import AttractionForm from './pages/AttractionForm/AttractionForm';
import { useDispatch } from 'react-redux';
import { setLiferayRoute } from './slices/commonSlice';
interface AppParams {
    route: string | null;
}

const App: React.FC<AppParams> = ({ route }) => {
    const dispatch = useDispatch();
    const expansionRouter = createHashRouter([
        // 🔹 General Pages
        {
            path: '/',
            element: <BusinessExpansionForm />
        }
    ]);
    const pitchFormRouter = createHashRouter([
        {
            path: '/',
            element: <PitchForm />
        }
    ]);

    const attractionRouter = createHashRouter([
        {
            path: '/',
            element: <AttractionForm isExpansion={false} />
        }
    ]);
    console.log(route);

    useEffect(() => {
        dispatch(setLiferayRoute(route));
    }, [route]);
    return (
        <>
            <ToastContainerWrapper />
            <ListTypeEntriesProvider>
                <div className="business-expansion-form">
                    {route === '/' && (
                        <RouterProvider router={expansionRouter} />
                    )}
                    {route === '/pitch-form' && (
                        <div className="business-expansion-form-wraper">
                            <RouterProvider router={pitchFormRouter} />
                        </div>
                    )}
                    {route === '/attraction' && (
                        <div className="business-expansion-form-wraper">
                            <RouterProvider router={attractionRouter} />
                        </div>
                    )}
                </div>
            </ListTypeEntriesProvider>
        </>
    );
};

export default App;
